import { memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";

import { setCredentialManagementShareSelectedUsers } from "redux/actions/portal/credentialManagementActionCreator";

const share_type_options = [
  { value: "edit", label: "Edit" },
  { value: "use", label: "Use" },
  { value: "view", label: "View" },
];

const DropdownShareType = ({ value }) => {
  const { credentialManangementShareSelectedUsers } = useSelector(
    (store) => store.portal.credentialManagement
  );
  const dispatch = useDispatch();

  const getDefaultValue = (auth0_id) => {
    const userExistToShare = credentialManangementShareSelectedUsers?.find(
      (user) => user?.user_id === auth0_id
    );

    if (userExistToShare) {
      return {
        value: userExistToShare?.share_type,
        label: share_type_options.find((option) => option.value === userExistToShare?.share_type)
          ?.label,
      };
    } else {
      return {
        value: "use",
        label: "Use",
      };
    }
  };

  const handleSelectShareType = (e, auth0_id) => {
    const { value } = e;
    const userExistToShare = credentialManangementShareSelectedUsers.find(
      (user) => user?.user_id === auth0_id
    );

    if (userExistToShare) {
      const updateSelectedUser = credentialManangementShareSelectedUsers.map((user) => {
        if (user?.user_id === auth0_id) {
          return {
            ...user,
            share_type: value,
          };
        }
        return user;
      });
      dispatch(setCredentialManagementShareSelectedUsers(updateSelectedUser));
    }
  };

  return (
    <SoftBox sx={{ width: "250px" }} className="inline-select-wrapper">
      <SoftSelect
        defaultValue={getDefaultValue(value)}
        options={share_type_options}
        placeholder="Select share type"
        onChange={(e) => handleSelectShareType(e, value)}
        isDisabled={
          !credentialManangementShareSelectedUsers?.some(
            (user) => user?.user_id === value
          )
        }
      />
    </SoftBox>
  );
}

export default memo(DropdownShareType);
